import { useState } from "react";
import { CenterPopup as AntdCenterPopup } from "antd-mobile";

const useCenterPopup = () => {
	const [visiblePopup, setVisiblePopup] = useState(false);

	const showPopup = () => {
		setVisiblePopup(true);
	};

	const closePopup = () => {
		setVisiblePopup(false);
	};

	return {
		visiblePopup,
		showPopup,
		closePopup,
		PopupComp: AntdCenterPopup,
	};
};

export default useCenterPopup;
